import { ReactElement } from 'react';
import { Box, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import {
  AppCheckBox,
  AppFormikDatePicker,
  AppFormikSelect,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';
import { useFormikContext } from 'formik';

const PolicyInformationCard = (): ReactElement => {
  const { values, setFieldValue }: any = useFormikContext();

  return (
    <Paper variant="outlined" className="policy-information-card">
      <Typography variant="h6">Policy Information</Typography>
      <Typography className="mt-2">
        Enter the basic information about this policy
      </Typography>
      <Grid container className="policy-grid">
        <Grid item md={6} xs={12}>
          <AppFormikTextField
            name="title"
            placeholder="Enter policy title"
            label="Policy Title*"
            outerLabel
          />
          <Typography component="span">
            The official title of the policy document (max 80 characters) 0/80
            characters
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <AppFormikTextField
            name="version"
            placeholder="1.0.0"
            label="Version*"
            outerLabel
          />
          <Typography component="span">
            Semantic versioning (major.minor.patch)
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <AppFormikTextField
            name="owner"
            placeholder="Enter policy title"
            label="Policy Owner*"
            outerLabel
          />
          <Typography component="span">
            Person responsible for maintaining this policy
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <Stack>
            <AppFormikDatePicker
              // disableToday
              autoFocus
              fullWidth
              className="mb-1"
              name="effectiveDate"
              testid="datepicker-dropdown"
              InputProps={{
                name: 'effectiveDate',
                'aria-labelledby': 'duedate-label',
                notched: false,
              }}
              label="Effective Date"
              outerLabel
              min
              placeholder="gg/mm/aaaa"
              renderInput={(props: any) => (
                <TextField {...props} fullWidth margin="normal" />
              )}
            />

            <Typography className="info-text">
              When this policy becomes effective
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <AppFormikSelect
        name="status"
        className="rework-selection"
        notched={false}
        labelId="fix-selection-label"
        testid="solicitor-dropdown"
        MenuProps={{
          className: 'menu-fix-selection single-fix-rework',
        }}
        outerLabel
        placeholder="Select Status"
        notEmphasized
        notSelectablePlaceholder
        label="Current status of the policy"
        items={['Draft', 'Review', 'Published', 'Archived']}
      />
      <Stack className="my-5" direction="row" spacing={2}>
        <AppCheckBox
          checked={values.acknowledgementRequired}
          name="acknowledgementRequired"
          onChange={(e: any) =>
            setFieldValue('acknowledgementRequired', e.target.checked)
          }
        />
        <Box className="require-typography">
          <Typography>Require Acknowledgement</Typography>
          <Typography component="span">
            If checked, users will need to acknowledge this policy
          </Typography>
        </Box>
      </Stack>
      <AppFormikTextArea
        name="description"
        label="Description"
        placeholder="Enter a brief description  of the policy ..."
        outerLabel
      />
    </Paper>
  );
};

export default PolicyInformationCard;
